// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on.
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageHeader } from '../../components/ui/page-header'
import '../../shared/shell/strings'

export const Route = createFileRoute('/platform/plans')({
  staticData: { screenId: 'ConsolePlansScreen', access: 'platform.org.read (edit: platform.plan.manage)' },
  component: ConsolePlansScreen,
})

function ConsolePlansScreen() {
  const { t } = useTranslation()
  return (
    <main data-testid="ConsolePlansScreen">
      <PageHeader title={t('shell.nav.plans')} titleTestId="consolePlans_titleValue" />
    </main>
  )
}
